import getListViewState from "../selectors/getListViewState";
import { owaComputedFn } from "owa-computed-fn";

export const isZeroSelectedItemParts: () => boolean = owaComputedFn(function IsZeroSelectedItemParts(): boolean {
    return getListViewState().expandedConversationViewState.selectedNodeIds.length === 0;
});

export const isOneSelectedItemParts: () => boolean = owaComputedFn(function IsOneSelectedItemParts(): boolean {
    return getListViewState().expandedConversationViewState.selectedNodeIds.length === 1;
});

export const isMultipleSelectedItemParts: () => boolean = owaComputedFn(function IsMultipleSelectedItemParts(): boolean {
    return getListViewState().expandedConversationViewState.selectedNodeIds.length > 1;
});
